// extracted by mini-css-extract-plugin
module.exports = {"container":"specialPage_container__2Y1di","sectionTitle":"specialPage_sectionTitle__2I_Ip"};